"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMAIL_GENERATION_DB_TYPE = exports.EMAIL_GENERATION_TYPE = exports.EMAIL_GENERATION_DATE_RANGE = exports.EMAIL_GENERATION_FREQUENCY = void 0;
var EMAIL_GENERATION_FREQUENCY;
(function (EMAIL_GENERATION_FREQUENCY) {
    EMAIL_GENERATION_FREQUENCY["DAILY"] = "DAILY";
    EMAIL_GENERATION_FREQUENCY["WEEKLY"] = "WEEKLY";
    EMAIL_GENERATION_FREQUENCY["MONTHLY"] = "MONTHLY";
})(EMAIL_GENERATION_FREQUENCY = exports.EMAIL_GENERATION_FREQUENCY || (exports.EMAIL_GENERATION_FREQUENCY = {}));
var EMAIL_GENERATION_DATE_RANGE;
(function (EMAIL_GENERATION_DATE_RANGE) {
    EMAIL_GENERATION_DATE_RANGE["TODAY"] = "TODAY";
    EMAIL_GENERATION_DATE_RANGE["YESTERDAY"] = "YESTERDAY";
    EMAIL_GENERATION_DATE_RANGE["LAST_FULL_WEEK"] = "LAST_FULL_WEEK";
    EMAIL_GENERATION_DATE_RANGE["CURRENT_WEEK"] = "CURRENT_WEEK";
    EMAIL_GENERATION_DATE_RANGE["FULL_CURRENT_WEEK"] = "FULL_CURRENT_WEEK";
    EMAIL_GENERATION_DATE_RANGE["LAST_FULL_MONTH"] = "LAST_FULL_MONTH";
    EMAIL_GENERATION_DATE_RANGE["CURRENT_MONTH"] = "CURRENT_MONTH";
    EMAIL_GENERATION_DATE_RANGE["CURRENT_YEAR"] = "CURRENT_YEAR";
})(EMAIL_GENERATION_DATE_RANGE = exports.EMAIL_GENERATION_DATE_RANGE || (exports.EMAIL_GENERATION_DATE_RANGE = {}));
var EMAIL_GENERATION_TYPE;
(function (EMAIL_GENERATION_TYPE) {
    EMAIL_GENERATION_TYPE["EMAIL"] = "EMAIL";
    EMAIL_GENERATION_TYPE["SMS"] = "SMS";
    EMAIL_GENERATION_TYPE["IN_APP"] = "IN_APP";
})(EMAIL_GENERATION_TYPE = exports.EMAIL_GENERATION_TYPE || (exports.EMAIL_GENERATION_TYPE = {}));
var EMAIL_GENERATION_DB_TYPE;
(function (EMAIL_GENERATION_DB_TYPE) {
    EMAIL_GENERATION_DB_TYPE["POSTGRES"] = "POSTGRES";
    EMAIL_GENERATION_DB_TYPE["BIGQUERY"] = "BIGQUERY";
})(EMAIL_GENERATION_DB_TYPE = exports.EMAIL_GENERATION_DB_TYPE || (exports.EMAIL_GENERATION_DB_TYPE = {}));
